import React from 'react';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from './utils/formConfig';
import useContent from './utils/useContent';

const GetTransactionPdfContent = () => {
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useContent();

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Get Pdf',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default GetTransactionPdfContent;
